// frontend/src/pages/Inbox/QuoteInbox.jsx

import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import PDFUploadZone from '../../components/Upload/PDFUploadZone';
import QuoteConfirmModal from '../../components/Modals/QuoteConfirmModal';
import { quotesAPI } from '../../services/api';

const QuoteInbox = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [clientMatch, setClientMatch] = useState(null);
  const [versionInfo, setVersionInfo] = useState(null);
  const [sellerMatch, setSellerMatch] = useState(null);  // ✅ NUEVO
  const [pdfMetadata, setPdfMetadata] = useState(null)
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [quoteModalOpen, setQuoteModalOpen] = useState(false);

  const handleUploadPDF = async (file) => {
    setIsUploading(true);
    setError(null);
    setSuccess(null);

    try {
      console.log('📤 Subiendo PDF de propuesta:', file.name);
      const response = await quotesAPI.uploadPDF(file);
      console.log('✅ Respuesta:', response.data);

            if (response.data.success) {
        // ✅ AGREGAR temp_files al data
        const dataWithFiles = {
          ...response.data.data,
          temp_files: response.data.temp_files
        };
  
        setUploadedData(dataWithFiles);
        setClientMatch(response.data.client_match);
        setVersionInfo(response.data.version_info);
        setSellerMatch(response.data.seller_suggestion);  // ✅ NUEVO (cambié seller_match por seller_suggestion)
        setPdfMetadata(response.data.pdf_metadata);       // ✅ NUEVO
        setQuoteModalOpen(true);
      }
       else {
        throw new Error(response.data.error || 'Error al procesar PDF');
      }
    } catch (err) {
      console.error('❌ Error:', err);
      const errorMsg = err.response?.data?.error || err.message || 'Error al procesar el PDF';
      setError(errorMsg);
    } finally {
      setIsUploading(false);
    }
  };

  const handleConfirmQuote = async (confirmData) => {
    try {
      console.log('✅ Confirmando propuesta:', confirmData);
      const response = await quotesAPI.confirm(confirmData);
      console.log('✅ Propuesta creada:', response.data);

      setSuccess(
        `Cotización ${response.data.quote.proposal_number} v${response.data.quote.version} creada exitosamente`
      );
      setQuoteModalOpen(false);

      setTimeout(() => {
        setUploadedData(null);
        setClientMatch(null);
        setVersionInfo(null);
        setSuccess(null);
      }, 5000);
    } catch (err) {
      console.error('❌ Error al confirmar:', err);
      throw err;
    }
  };

  return (
    <>
      {/* ✅ HEADER CON GRADIENTE MAS+ */}
      <div className="min-height-300 bg-gradient-primary position-absolute w-100"></div>

      <Container fluid className="py-0">
        {/* ✅ TÍTULO CON ICONOS NUCLEO */}
        <Row className="mb-4">
          <Col>
            <h6 className="h2 text-white d-inline-block mb-0">
              <i className="ni ni-single-copy-04 me-2"></i>
              Inbox - propuestas
            </h6>
            <p className="text-white text-sm mb-0 opacity-8">
              Sube y procesa propuestas en PDF automáticamente
            </p>
          </Col>
        </Row>

        {/* ✅ ALERTAS CON ICONOS Y SOMBRAS */}
        {success && (
          <Row className="mb-4">
            <Col>
              <div className="alert alert-success alert-dismissible fade show shadow-sm" role="alert">
                <span className="alert-icon">
                  <i className="ni ni-like-2"></i>
                </span>
                <span className="alert-text">
                  <strong>¡Éxito!</strong> {success}
                </span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSuccess(null)}
                  aria-label="Close"
                ></button>
              </div>
            </Col>
          </Row>
        )}

        {error && (
          <Row className="mb-4">
            <Col>
              <div className="alert alert-danger alert-dismissible fade show shadow-sm" role="alert">
                <span className="alert-icon">
                  <i className="ni ni-support-16"></i>
                </span>
                <span className="alert-text">
                  <strong>Error:</strong> {error}
                </span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError(null)}
                  aria-label="Close"
                ></button>
              </div>
            </Col>
          </Row>
        )}

        {/* ✅ CONTENIDO PRINCIPAL */}
        <Row>
          <Col lg="8">
            {/* ✅ CARD DE UPLOAD CON SOMBRA */}
            <Card className="shadow border-0 mb-4">
              <CardHeader className="bg-transparent pb-0">
                <h6 className="text-uppercase text-xs font-weight-bold mb-0">
                  <i className="ni ni-cloud-upload-96 me-2 text-primary"></i>
                  Subir propuesta
                </h6>
              </CardHeader>
              <CardBody className="p-3">
                <PDFUploadZone
                  onUpload={handleUploadPDF}
                  maxSize={10}
                  isUploading={isUploading}
                />
              </CardBody>
            </Card>
          </Col>

          <Col lg="4">
            {/* ✅ CARD DE INSTRUCCIONES CON TIMELINE */}
            <Card className="shadow border-0 mb-4">
              <CardHeader className="bg-gradient-primary pb-3">
                <h6 className="mb-0 text-white">
                  <i className="ni ni-bulb-61 me-2"></i>
                  Instrucciones
                </h6>
              </CardHeader>
              <CardBody className="p-3">
                <div className="timeline timeline-one-side">
                  <div className="timeline-block mb-3">
                    <span className="timeline-step bg-gradient-success">
                      <i className="ni ni-cloud-upload-96"></i>
                    </span>
                    <div className="timeline-content">
                      <small className="text-muted font-weight-bold text-uppercase">Paso 1</small>
                      <h6 className="text-sm mt-1 mb-0 font-weight-bold">Sube el PDF</h6>
                      <p className="text-xs mt-1 mb-0 text-muted">
                        Arrastra o selecciona el archivo de propuesta
                      </p>
                    </div>
                  </div>

                  <div className="timeline-block mb-3">
                    <span className="timeline-step bg-gradient-info">
                      <i className="ni ni-settings-gear-65"></i>
                    </span>
                    <div className="timeline-content">
                      <small className="text-muted font-weight-bold text-uppercase">Paso 2</small>
                      <h6 className="text-sm mt-1 mb-0 font-weight-bold">Extracción automática</h6>
                      <p className="text-xs mt-1 mb-0 text-muted">
                        El sistema extrae los datos del PDF
                      </p>
                    </div>
                  </div>

                  <div className="timeline-block mb-3">
                    <span className="timeline-step bg-gradient-warning">
                      <i className="ni ni-check-bold"></i>
                    </span>
                    <div className="timeline-content">
                      <small className="text-muted font-weight-bold text-uppercase">Paso 3</small>
                      <h6 className="text-sm mt-1 mb-0 font-weight-bold">Revisa y confirma</h6>
                      <p className="text-xs mt-1 mb-0 text-muted">
                        Verifica la información extraída
                      </p>
                    </div>
                  </div>

                  <div className="timeline-block">
                    <span className="timeline-step bg-gradient-primary">
                      <i className="ni ni-archive-2"></i>
                    </span>
                    <div className="timeline-content">
                      <small className="text-muted font-weight-bold text-uppercase">Paso 4</small>
                      <h6 className="text-sm mt-1 mb-0 font-weight-bold">Archivo automático</h6>
                      <p className="text-xs mt-1 mb-0 text-muted">
                        El PDF se guarda en el sistema
                      </p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>

            {/* ✅ CARD DE INFORMACIÓN */}
            <Card className="shadow border-0">
              <CardHeader className="bg-transparent pb-0">
                <h6 className="text-uppercase text-xs font-weight-bold mb-0">
                  <i className="ni ni-bullet-list-67 me-2 text-primary"></i>
                  Información
                </h6>
              </CardHeader>
              <CardBody className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <span className="text-sm font-weight-bold">Tamaño máximo</span>
                  <span className="badge badge-sm bg-gradient-info">
                    <i className="ni ni-ruler-pencil me-1"></i>
                    10 MB
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <span className="text-sm font-weight-bold">Formato aceptado</span>
                  <span className="badge badge-sm bg-gradient-success">
                    <i className="ni ni-single-copy-04 me-1"></i>
                    PDF
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-sm font-weight-bold">Procesamiento</span>
                  <span className="badge badge-sm bg-gradient-primary">
                    <i className="ni ni-settings-gear-65 me-1"></i>
                    Automático
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* ✅ MODAL */}
            <QuoteConfirmModal
        isOpen={quoteModalOpen}
        toggle={() => setQuoteModalOpen(false)}
        data={uploadedData}
        clientMatch={clientMatch}
        versionInfo={versionInfo}
        sellerMatch={sellerMatch}        // ✅ NUEVO
        pdfMetadata={pdfMetadata}        // ✅ NUEVO
        onConfirm={handleConfirmQuote}
      />
    </>
  );
};

export default QuoteInbox;
